import {
  required,
  maxLength,
  minLength,
  regex,
  number,
  email,
} from "react-admin";

export const mobilePhoneValidation = [
  required(),
  maxLength(8),
  number(),
  regex(/^\S*\d{8}$/),
];

export const mobilePhone12DigitsValidation = [
  required(),
  maxLength(12),
  number(),
  regex(/^\S*\d{8}$/),
];

export const mobilePhoneNoValidation = [
  required(),
  number(),
  regex(/^\S*\d{1}$/),
];

export const postalCodeValidation = [required(), regex(/^\d{1,12}$/)];

export const emailValidation = [required(), email()];

export const emailNoRequiredValidation = [email()];

export const vaNumberValidation = [minLength(11), maxLength(11), number()];

export const isCalculationCostCreateStudentInvalid = (
  formData: formCreateStudent,
  selectedSchool: ISchool | null,
) => {
  let regularInvalid = true;
  let ccaInvalid = true;

  // Regular Only
  if (
    formData.isNotTakeSchedule === false &&
    formData.scheduleType === "regular"
  ) {
    if (
      formData.schoolId &&
      formData.academicYearId &&
      formData.levelId &&
      formData.startedAt &&
      formData.toAndFrom &&
      formData.postalCode &&
      (formData.isMonday ||
        formData.isFriday ||
        formData.isThursday ||
        formData.isTuesday ||
        formData.isWednesday) &&
      // If subsidy toggle is false, ignore the subsidyPercentage and period
      (!formData.isApplyStudentSubsidy ||
        (formData.subsidyPercentage &&
          formData.subsidyPercentage > 0 &&
          formData.subsidyPercentage <= 100 &&
          formData.periodStartDate &&
          formData.periodEndDate))
    ) {
      regularInvalid = false;
      ccaInvalid = false;
    }
  }
  // CCA Only: Fixed Location
  if (
    formData.isNotTakeSchedule === false &&
    formData.scheduleType === "cca" &&
    formData.dropOffAddressType === "fixed_location"
  ) {
    if (
      formData.schoolId &&
      formData.ccaAcademicYearId &&
      formData.levelId &&
      formData.ccaStartedAt
    ) {
      if (
        !formData.isCcaMonday &&
        !formData.isCcaFriday &&
        !formData.isCcaThursday &&
        !formData.isCcaTuesday &&
        !formData.isCcaWednesday
      ) {
        ccaInvalid = true;
      } else {
        let validMonday = true;
        let validTuesday = true;
        let validWednesday = true;
        let validThursday = true;
        let validFriday = true;

        if (
          formData.isCcaMonday &&
          ((!formData.isUseOneFixedLocation &&
            !formData.fixedLocationMondayId) ||
            (selectedSchool?.isAllowParentSelectWave && !formData.waveMondayId))
        ) {
          validMonday = false;
        }

        if (
          formData.isCcaTuesday &&
          ((!formData.isUseOneFixedLocation &&
            !formData.fixedLocationTuesdayId) ||
            (selectedSchool?.isAllowParentSelectWave &&
              !formData.waveTuesdayId))
        ) {
          validTuesday = false;
        }

        if (
          formData.isCcaWednesday &&
          ((!formData.isUseOneFixedLocation &&
            !formData.fixedLocationWednesdayId) ||
            (selectedSchool?.isAllowParentSelectWave &&
              !formData.waveWednesdayId))
        ) {
          validWednesday = false;
        }

        if (
          formData.isCcaThursday &&
          ((!formData.isUseOneFixedLocation &&
            !formData.fixedLocationThursdayId) ||
            (selectedSchool?.isAllowParentSelectWave &&
              !formData.waveThursdayId))
        ) {
          validThursday = false;
        }

        if (
          formData.isCcaFriday &&
          ((!formData.isUseOneFixedLocation &&
            !formData.fixedLocationFridayId) ||
            (selectedSchool?.isAllowParentSelectWave && !formData.waveFridayId))
        ) {
          validFriday = false;
        }

        if (formData.isUseOneFixedLocation && !formData.fixedLocationId) {
          ccaInvalid = true;
        } else {
          ccaInvalid = !(
            validMonday &&
            validTuesday &&
            validWednesday &&
            validThursday &&
            validFriday
          );
        }

        regularInvalid = false;
      }
    }
  }
  // CCA Only: Door to Door Location
  if (
    formData.isNotTakeSchedule === false &&
    formData.scheduleType === "cca" &&
    formData.dropOffAddressType === "door_to_door"
  ) {
    if (
      formData.schoolId &&
      formData.ccaAcademicYearId &&
      formData.levelId &&
      formData.ccaPostalCode &&
      formData.ccaStartedAt &&
      (formData.isCcaMonday ||
        formData.isCcaFriday ||
        formData.isCcaThursday ||
        formData.isCcaTuesday ||
        formData.isCcaWednesday)
    ) {
      regularInvalid = false;
      ccaInvalid = false;
    }
  }

  // Both: Regular
  if (
    formData.isNotTakeSchedule === false &&
    formData.scheduleType === "both"
  ) {
    if (
      formData.schoolId &&
      formData.academicYearId &&
      formData.levelId &&
      formData.startedAt &&
      formData.toAndFrom &&
      formData.postalCode &&
      (formData.isMonday ||
        formData.isFriday ||
        formData.isThursday ||
        formData.isTuesday ||
        formData.isWednesday) &&
      // If subsidy toggle is false, ignore the subsidyPercentage and period
      (!formData.isApplyStudentSubsidy ||
        (formData.subsidyPercentage &&
          formData.subsidyPercentage > 0 &&
          formData.subsidyPercentage <= 100 &&
          formData.periodStartDate &&
          formData.periodEndDate))
    ) {
      regularInvalid = false;
    }
  }
  // Both: CCA Fixed Location
  if (
    formData.isNotTakeSchedule === false &&
    formData.scheduleType === "both" &&
    formData.dropOffAddressType === "fixed_location"
  ) {
    if (
      formData.schoolId &&
      formData.ccaAcademicYearId &&
      formData.levelId &&
      formData.ccaStartedAt
    ) {
      if (
        !formData.isCcaMonday &&
        !formData.isCcaFriday &&
        !formData.isCcaThursday &&
        !formData.isCcaTuesday &&
        !formData.isCcaWednesday
      ) {
        ccaInvalid = true;
      } else {
        let validMonday = true;
        let validTuesday = true;
        let validWednesday = true;
        let validThursday = true;
        let validFriday = true;

        if (
          formData.isCcaMonday &&
          ((!formData.isUseOneFixedLocation &&
            !formData.fixedLocationMondayId) ||
            (selectedSchool?.isAllowParentSelectWave && !formData.waveMondayId))
        ) {
          validMonday = false;
        }

        if (
          formData.isCcaTuesday &&
          ((!formData.isUseOneFixedLocation &&
            !formData.fixedLocationTuesdayId) ||
            (selectedSchool?.isAllowParentSelectWave &&
              !formData.waveTuesdayId))
        ) {
          validTuesday = false;
        }

        if (
          formData.isCcaWednesday &&
          ((!formData.isUseOneFixedLocation &&
            !formData.fixedLocationWednesdayId) ||
            (selectedSchool?.isAllowParentSelectWave &&
              !formData.waveWednesdayId))
        ) {
          validWednesday = false;
        }

        if (
          formData.isCcaThursday &&
          ((!formData.isUseOneFixedLocation &&
            !formData.fixedLocationThursdayId) ||
            (selectedSchool?.isAllowParentSelectWave &&
              !formData.waveThursdayId))
        ) {
          validThursday = false;
        }

        if (
          formData.isCcaFriday &&
          ((!formData.isUseOneFixedLocation &&
            !formData.fixedLocationFridayId) ||
            (selectedSchool?.isAllowParentSelectWave && !formData.waveFridayId))
        ) {
          validFriday = false;
        }

        if (formData.isUseOneFixedLocation && !formData.fixedLocationId) {
          ccaInvalid = true;
        } else {
          ccaInvalid = !(
            validMonday &&
            validTuesday &&
            validWednesday &&
            validThursday &&
            validFriday
          );
        }
      }
    }
  }
  // Both: CCA Door to Door Location
  if (
    formData.isNotTakeSchedule === false &&
    formData.scheduleType === "both" &&
    formData.dropOffAddressType === "door_to_door"
  ) {
    if (
      formData.schoolId &&
      formData.ccaAcademicYearId &&
      formData.levelId &&
      formData.ccaPostalCode &&
      formData.ccaStartedAt &&
      (formData.isCcaMonday ||
        formData.isCcaFriday ||
        formData.isCcaThursday ||
        formData.isCcaTuesday ||
        formData.isCcaWednesday)
    ) {
      ccaInvalid = false;
    }
  }

  return ccaInvalid || regularInvalid;
};

export const calculationCostUpdateScheduleValidation = (
  formData: formUpdateSchedule,
) => {
  if (
    formData.studentId &&
    formData.academicYearId &&
    formData.startedAt &&
    formData.endedAt
  ) {
    // If the student is taking the schedule
    if (!formData.isNotTaking) {
      // Check for required address fields and at least one weekday
      const hasValidAddress =
        formData.street &&
        formData.postalCode &&
        formData.wayType &&
        (formData.isMonday ||
          formData.isFriday ||
          formData.isThursday ||
          formData.isTuesday ||
          formData.isWednesday);

      // Subsidy toggle validation
      const subsidyInvalid =
        formData.isApplyStudentSubsidy === true &&
        (formData.subsidyPercentage === undefined ||
          formData.subsidyPercentage === null ||
          isNaN(formData.subsidyPercentage) ||
          formData.subsidyPercentage < 0 ||
          formData.subsidyPercentage >= 100);

      if (hasValidAddress && !subsidyInvalid) {
        return false; // All conditions met
      } else {
        return true; // Missing address, weekday, or subsidy info
      }
    } else {
      return false; // Not taking schedule, no need for further validation
    }
  } else {
    return true;
  }
};

export const calculationCostUpdateCcaScheduleValidation = (
  formData: formUpdateCcaSchedule,
) => {
  if (
    formData.studentId &&
    formData.ccaAcademicYearId &&
    formData.ccaStartedAt &&
    formData.ccaEndedAt
  ) {
    if (!formData.isNotTaking) {
      if (
        formData.isMonday ||
        formData.isFriday ||
        formData.isThursday ||
        formData.isTuesday ||
        formData.isWednesday
      ) {
        if (!formData.dropOffType) {
          return true;
        }

        if (formData.dropOffType === "fixed_location") {
          if (formData.isUseOneFixedLocation && !formData.fixedLocationId) {
            return true;
          }

          if (
            formData.isMonday &&
            ((!formData.isUseOneFixedLocation &&
              !formData.fixedLocationMondayId) ||
              (formData.allowSelectWave && !formData.waveMondayId))
          ) {
            return true;
          }

          if (
            formData.isTuesday &&
            ((!formData.isUseOneFixedLocation &&
              !formData.fixedLocationTuesdayId) ||
              (formData.allowSelectWave && !formData.waveTuesdayId))
          ) {
            return true;
          }

          if (
            formData.isWednesday &&
            ((!formData.isUseOneFixedLocation &&
              !formData.fixedLocationWednesdayId) ||
              (formData.allowSelectWave && !formData.waveWednesdayId))
          ) {
            return true;
          }

          if (
            formData.isThursday &&
            ((!formData.isUseOneFixedLocation &&
              !formData.fixedLocationThursdayId) ||
              (formData.allowSelectWave && !formData.waveThursdayId))
          ) {
            return true;
          }

          if (
            formData.isFriday &&
            ((!formData.isUseOneFixedLocation &&
              !formData.fixedLocationFridayId) ||
              (formData.allowSelectWave && !formData.waveFridayId))
          ) {
            return true;
          }
        }

        if (formData.dropOffType === "door_to_door" && !formData.postalCode) {
          return true;
        }

        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  } else {
    return true;
  }
};

export const disabledCommercialDocumentCreateButton = (formData: any) => {
  if (
    formData.schoolId &&
    formData.price &&
    formData.description &&
    formData.tbfCode &&
    formData.projectCode
  ) {
    if (formData.type === "invoice" && formData.dueDate) {
      if (formData.deferralCode && !formData.deferralStartDate) {
        return true;
      }

      return false;
    }

    {
      /* @TODO : Disable this first because user want to do reimbursement with CN
       ** will change this later after have a long term solution
       */
    }
    // if (
    //   formData.type === "credit_note" &&
    //   (!formData.invoiceReferenceNumber ||
    //     formData.invoiceReferenceNumber.includes(" "))
    // ) {
    //   return true;
    // } else {
    //   return false;
    // }

    if (formData.type === "credit_note") {
      return false;
    }
  }

  return true;
};

export const availableOnlySuperAdminAndAdmin = () => {
  const roles: string[] = localStorage.getItem("roles")
    ? localStorage.getItem("roles").split(",")
    : [];

  return roles.includes("superadmin") || roles.includes("admin");
};

export const availableOnlySuperAdminAndCustomerServices = () => {
  const roles: string[] = localStorage.getItem("roles")
    ? localStorage.getItem("roles").split(",")
    : [];

  return roles.includes("superadmin") || roles.includes("customerservice");
};

export const availableOnlySuperAdminAndOperations = () => {
  const roles: string[] = localStorage.getItem("roles")
    ? localStorage.getItem("roles").split(",")
    : [];

  return roles.includes("superadmin") || roles.includes("operation");
};

export const availableOnlySuperAdmin = () => {
  const roles: string[] = localStorage.getItem("roles")
    ? localStorage.getItem("roles").split(",")
    : [];

  return roles.includes("superadmin");
};

export const calculationCostWidgetValidation = (formData: any) => {
  if (
    formData.locationData?.POSTAL &&
    formData.locationData?.LATITUDE &&
    formData.locationData?.LONGITUDE
  ) {
    return false;
  } else {
    return true;
  }
};

export const calculationCostStudentWidgetValidation = (formData: any) => {
  let regularInvalid = true;
  let ccaInvalid = true;

  // Regular Only
  if (formData.scheduleType === "regular") {
    if (
      formData.academicYearId &&
      formData.date &&
      formData.wayType &&
      formData.postalCode &&
      formData.street &&
      (formData.isMonday ||
        formData.isFriday ||
        formData.isThursday ||
        formData.isTuesday ||
        formData.isWednesday)
    ) {
      regularInvalid = false;
      ccaInvalid = false;
    }
  }
  // CCA Only: Fixed Location
  if (
    formData.scheduleType === "cca" &&
    formData.dropOffType === "fixed_location"
  ) {
    if (formData.ccaAcademicYearId && formData.ccaDate) {
      if (
        !formData.isCcaMonday &&
        !formData.isCcaFriday &&
        !formData.isCcaThursday &&
        !formData.isCcaTuesday &&
        !formData.isCcaWednesday
      ) {
        ccaInvalid = true;
      } else {
        let validMonday = true;
        let validTuesday = true;
        let validWednesday = true;
        let validThursday = true;
        let validFriday = true;

        if (
          formData.isCcaMonday &&
          !formData.isUseOneFixedLocation &&
          !formData.fixedLocationMondayId
        ) {
          validMonday = false;
        }

        if (
          formData.isCcaTuesday &&
          !formData.isUseOneFixedLocation &&
          !formData.fixedLocationTuesdayId
        ) {
          validTuesday = false;
        }

        if (
          formData.isCcaWednesday &&
          !formData.isUseOneFixedLocation &&
          !formData.fixedLocationWednesdayId
        ) {
          validWednesday = false;
        }

        if (
          formData.isCcaThursday &&
          !formData.isUseOneFixedLocation &&
          !formData.fixedLocationThursdayId
        ) {
          validThursday = false;
        }

        if (
          formData.isCcaFriday &&
          !formData.isUseOneFixedLocation &&
          !formData.fixedLocationFridayId
        ) {
          validFriday = false;
        }

        if (formData.isUseOneFixedLocation && !formData.fixedLocationId) {
          ccaInvalid = true;
        } else {
          ccaInvalid = !(
            validMonday &&
            validTuesday &&
            validWednesday &&
            validThursday &&
            validFriday
          );
        }

        regularInvalid = false;
      }
    }
  }
  // CCA Only: Door to Door Location
  if (
    formData.scheduleType === "cca" &&
    formData.dropOffType === "door_to_door"
  ) {
    if (
      formData.ccaAcademicYearId &&
      formData.ccaDate &&
      formData.ccaPostalCode &&
      formData.ccaStreet &&
      (formData.isCcaMonday ||
        formData.isCcaFriday ||
        formData.isCcaThursday ||
        formData.isCcaTuesday ||
        formData.isCcaWednesday)
    ) {
      regularInvalid = false;
      ccaInvalid = false;
    }
  }

  // Both: Regular
  if (formData.scheduleType === "both") {
    if (
      formData.academicYearId &&
      formData.date &&
      formData.wayType &&
      formData.postalCode &&
      formData.street &&
      (formData.isMonday ||
        formData.isFriday ||
        formData.isThursday ||
        formData.isTuesday ||
        formData.isWednesday)
    ) {
      regularInvalid = false;
    }
  }
  // Both: CCA Fixed Location
  if (
    formData.scheduleType === "both" &&
    formData.dropOffType === "fixed_location"
  ) {
    if (formData.ccaAcademicYearId && formData.ccaDate) {
      if (
        !formData.isCcaMonday &&
        !formData.isCcaFriday &&
        !formData.isCcaThursday &&
        !formData.isCcaTuesday &&
        !formData.isCcaWednesday
      ) {
        ccaInvalid = true;
      } else {
        let validMonday = true;
        let validTuesday = true;
        let validWednesday = true;
        let validThursday = true;
        let validFriday = true;

        if (
          formData.isCcaMonday &&
          !formData.isUseOneFixedLocation &&
          !formData.fixedLocationMondayId
        ) {
          validMonday = false;
        }

        if (
          formData.isCcaTuesday &&
          !formData.isUseOneFixedLocation &&
          !formData.fixedLocationTuesdayId
        ) {
          validTuesday = false;
        }

        if (
          formData.isCcaWednesday &&
          !formData.isUseOneFixedLocation &&
          !formData.fixedLocationWednesdayId
        ) {
          validWednesday = false;
        }

        if (
          formData.isCcaThursday &&
          !formData.isUseOneFixedLocation &&
          !formData.fixedLocationThursdayId
        ) {
          validThursday = false;
        }

        if (
          formData.isCcaFriday &&
          !formData.isUseOneFixedLocation &&
          !formData.fixedLocationFridayId
        ) {
          validFriday = false;
        }

        if (formData.isUseOneFixedLocation && !formData.fixedLocationId) {
          ccaInvalid = true;
        } else {
          ccaInvalid = !(
            validMonday &&
            validTuesday &&
            validWednesday &&
            validThursday &&
            validFriday
          );
        }
      }
    }
  }
  // Both: CCA Door to Door Location
  if (
    formData.scheduleType === "both" &&
    formData.dropOffType === "door_to_door"
  ) {
    if (
      formData.ccaAcademicYearId &&
      formData.ccaPostalCode &&
      formData.ccaDate &&
      formData.ccaStreet &&
      (formData.isCcaMonday ||
        formData.isCcaFriday ||
        formData.isCcaThursday ||
        formData.isCcaTuesday ||
        formData.isCcaWednesday)
    ) {
      ccaInvalid = false;
    }
  }

  return regularInvalid || ccaInvalid;
};

export const isSuperAdmin = () => {
  const roles: string[] = localStorage.getItem("roles")
    ? localStorage.getItem("roles").split(",")
    : [];

  return roles.includes("superadmin");
};

export const isAssignedSubcontractorRequiredValidation = (formData: any) => {
  if (
    formData.assignedSubcontractor?.subcontractorId &&
    formData.assignedSubcontractor?.vehicleSize &&
    formData.assignedSubcontractor?.startDate &&
    formData.assignedSubcontractor?.endDate
  ) {
    return true;
  } else {
    return false;
  }
};

export const isValidTimeRangeValidation = (
  fromTime: string,
  toTime: string,
) => {
  const minTime = "00:00:00";
  const maxTime = "23:59:59";

  // Ensure times are within the valid range
  if (
    fromTime < minTime ||
    fromTime > maxTime ||
    toTime < minTime ||
    toTime > maxTime
  ) {
    return false;
  }

  return toTime >= fromTime;
};

export const calculationCostApproveCcaStudentRenewalWithScheduleValidation = (
  formData: formUpdateCcaSchedule,
) => {
  if (
    formData.studentId &&
    formData.ccaAcademicYearId &&
    formData.ccaStartedAt &&
    formData.ccaEndedAt
  ) {
    if (
      formData.isMonday ||
      formData.isFriday ||
      formData.isThursday ||
      formData.isTuesday ||
      formData.isWednesday
    ) {
      if (!formData.dropOffType) {
        return true;
      }

      if (formData.dropOffType === "fixed_location") {
        if (formData.isUseOneFixedLocation && !formData.fixedLocationId) {
          return true;
        }

        if (
          formData.isMonday &&
          ((!formData.isUseOneFixedLocation &&
            !formData.fixedLocationMondayId) ||
            (formData.allowSelectWave && !formData.waveMondayId))
        ) {
          return true;
        }

        if (
          formData.isTuesday &&
          ((!formData.isUseOneFixedLocation &&
            !formData.fixedLocationTuesdayId) ||
            (formData.allowSelectWave && !formData.waveTuesdayId))
        ) {
          return true;
        }

        if (
          formData.isWednesday &&
          ((!formData.isUseOneFixedLocation &&
            !formData.fixedLocationWednesdayId) ||
            (formData.allowSelectWave && !formData.waveWednesdayId))
        ) {
          return true;
        }

        if (
          formData.isThursday &&
          ((!formData.isUseOneFixedLocation &&
            !formData.fixedLocationThursdayId) ||
            (formData.allowSelectWave && !formData.waveThursdayId))
        ) {
          return true;
        }

        if (
          formData.isFriday &&
          ((!formData.isUseOneFixedLocation &&
            !formData.fixedLocationFridayId) ||
            (formData.allowSelectWave && !formData.waveFridayId))
        ) {
          return true;
        }
      }

      if (formData.dropOffType === "door_to_door" && !formData.postalCode) {
        return true;
      }

      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
};
